import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import VueSignaturePad from "vue-signature-pad";
import VueSimpleAlert from "vue-simple-alert";
import Toasted from 'vue-toasted';
import router from "./router/index";
import store from "./store/index";
import VueSession from 'vue-session'
import JsonExcel from "vue-json-excel";
import moment from 'moment';
import swatches from 'vue-swatches';
import "vue-swatches/dist/vue-swatches.css"
import VuetifyMoney from './plugins/vuetify-money'
import VDatetimePicker from 'v-datetime-field'
import 'roboto-fontface/css/roboto/roboto-fontface.css'

let optionsToasted = {
  keepOnHover: true,
  iconPack: 'mdi'
}

Vue.component("downloadExcel", JsonExcel);
Vue.use(Toasted, optionsToasted);
Vue.use(VueSignaturePad);
Vue.use(VueSimpleAlert);
Vue.use(VueSession);
Vue.use(moment);
Vue.component('swatches', swatches);
Vue.use(VDatetimePicker)

Vue.config.productionTip = false


function restoreSession () {

  // const self = Vue.prototype
  const loggedIn = Vue.prototype.$session.get('user_id') !== undefined ? true : false
  if (loggedIn) {

    store.commit('global/saveLoggedState', true)
    store.commit('global/saveLoginTokenState', Vue.prototype.$session.get('user_token'))
    store.commit('global/saveLoginNameState', Vue.prototype.$session.get('user_name'))
    store.commit('global/saveLoginPerfilState', Vue.prototype.$session.get('user_perfil'))
    store.commit('global/saveOpcionesMenu', Vue.prototype.$session.get('user_menus'))     
    store.commit('global/savePermisosOpcionMenu', Vue.prototype.$session.get('user_permisos'))    
    store.commit('global/saveLoginIdState', Vue.prototype.$session.get('user_id'))
    store.commit('global/saveEstadoRegistroState', Vue.prototype.$session.get('estadoregistro'))
    store.commit('global/saveResponsables', Vue.prototype.$session.get('user_responsables'))
    
    store.commit('global/saveLoginIdEmpresaState', Vue.prototype.$session.get('user_empresa_id'))
    store.commit('global/saveLoginEmpresaState', Vue.prototype.$session.get('user_empresa'))
     
    store.commit('global/savecolorappState', Vue.prototype.$session.get('colorapp'))

    store.commit('global/saveminimacuantiaproveedorState', Vue.prototype.$session.get('minimacuantiaproveedor'))
    store.commit('global/savemenorcuantiaproveedorState', Vue.prototype.$session.get('menorcuantiaproveedor'))

    store.commit('global/saveminimacuantiaclientesState', Vue.prototype.$session.get('minimacuantiaclientes'))
    store.commit('global/savemenorcuantiaclientesState', Vue.prototype.$session.get('menorcuantiaclientes'))

    store.commit('global/saveMetodoFirmaRegistroState', Vue.prototype.$session.get('metodofirmaregistro'))
    store.commit('global/saveTipoRegistroState', Vue.prototype.$session.get('tiporegistro'))
    store.commit('global/saveselectidregistroState', Vue.prototype.$session.get('selectidregistro'))
    store.commit('global/saveselectidempresaState', Vue.prototype.$session.get('selectidempresa'))
    store.commit('global/savemultipleregistroState', Vue.prototype.$session.get('multipleregistro'))
    

    console.log('restoreSesion')
  }else{
    //this.$store.commit('global/savecolorappState', 0)
  }
}

restoreSession()

new Vue({
  vuetify,
  VuetifyMoney,
  store,  
  router,  
  render: h => h(App)
}).$mount('#app')
